import FlexStack from "../../components/Common/flex-stack";
import {Widget} from "../../components/Common";
import React, {PropsWithChildren} from "react";
import {Chip, TableContainer} from "@mui/material";
import {DataTable} from "../../components/Table/data-table";
import {InfoBox, WarningBox} from "../../components/Common/alerts";
import {Done} from "@mui/icons-material";
import {useSubscription, useSubscriptionHistory} from "../../hooks/use-subscription";
import {SubscriptionsTestApi, SubscriptionType, SubscriptionTypeValues} from "../../api/generated/herds-licensing";
import FormattedDate from "../../components/Common/formatted-date";
import {getDurationDays} from "../../components/AnimalDashboard/Pregnancy/pregnancy-utils";
import {DateTime} from "luxon";
import {useQuery} from "@tanstack/react-query";
import ApiConfig from "../../api/config/api-config";
import {useBreederInfo} from "../../hooks/use-breeders";
import {Subscription} from "../../services/subscription-service";

const FlexWidget = (props: PropsWithChildren<{ displayName: React.ReactNode }>) => (
    <Widget displayName={props.displayName}>
        <FlexStack>
            {props.children}
        </FlexStack>
    </Widget>
);


const InvoiceWidget = () => {
    const invoices = [{
        id: '1',
        period: 'Testphase',
        amount: '0,00 €',
        status: <Chip icon={<Done />} size="small" color="success" variant="outlined" label="Bezahlt" />,
        document: '---',
    }];

    return (
        <FlexWidget displayName="Rechnungen">
            <TableContainer>
                <DataTable data={invoices} columns={[
                    {id: 'period', header: 'Zeitraum', accessor: 'period'},
                    {id: 'amount', header: 'Betrag', accessor: 'amount'},
                    {id: 'status', header: 'Status', accessor: 'status'},
                    {id: 'document', header: 'Dokument', accessor: 'document'},
                ]}/>
            </TableContainer>
        </FlexWidget>
    );
};

// TODO remove after successful tests
const subscriptionsTestApi = new SubscriptionsTestApi(new ApiConfig());
const SubscriptionTestingWidget = () => {
    const {data: breederInfo} = useBreederInfo();
    const {history = []} = useSubscriptionHistory(breederInfo.id);
    const activeQuery = useQuery({
        queryKey: ['subscription', 'test', 'active'],
        queryFn: async () => await subscriptionsTestApi.testActive(),
    });
    const expiredQuery = useQuery({
        queryKey: ['subscription', 'test', 'expired'],
        queryFn: async () => await subscriptionsTestApi.testExpired(),
    });

    return (
        <FlexWidget displayName="Testing">
            <div>Active: {activeQuery.data} ({activeQuery.isLoading ? 'loading...' : (activeQuery.isError && '!!!')})</div>
            <div>Expired: {expiredQuery.data} ({expiredQuery.isLoading ? 'loading...' : (expiredQuery.isError && '!!!')})</div>
            <div>
                <h3>History</h3>
                <ol>
                    {history.map(log => (<li>{log}</li>))}
                </ol>
            </div>
        </FlexWidget>
    );
}

const subscriptionTypeText = (type: SubscriptionType) => {
    switch (type) {
        case SubscriptionTypeValues.TRIAL:
            return 'Testphase';
        case SubscriptionTypeValues.INDIVIDUAL:
            return 'Einzelabo';
        default:
            return 'Abo';
    }
};

const CurrentSubscription = ({subscription}: { subscription: Subscription }) => {
    const {expiresAt, isExpired} = subscription;
    if (isExpired) {
        return (
            <WarningBox>
                {subscriptionTypeText(subscription.type)} am <FormattedDate date={expiresAt}/> abgelaufen!
                (vor {getDurationDays({start: expiresAt, end: DateTime.now()})} Tagen)
            </WarningBox>
        );
    }
    return (
        <div>
            {subscriptionTypeText(subscription.type)} gültig bis: <FormattedDate date={expiresAt}/> ({getDurationDays({
            start: DateTime.now(),
            end: expiresAt
        })} Tage verbleibend)
        </div>
    );
};

export const SubscriptionOverviewPage = () => {
    const {subscription} = useSubscription();

//     const cancelSubscription = () => {
//         if (window.confirm(`Das Abo bleibt bis XXXX aktiv. Danach steht das Konto noch weitere 90 Tage im Lesemodus zur Verfügung.
// Du erhältst unmittelbar eine E-Mail-Bestätigung. Rechnungen & Datenexport findest du im Abo-Center.
//
// Wirklich kündigen?`)) {
//             window.alert('Abo erfolgreich gekündigt.');
//         }
//     };

    // const changeSubscription = () => window.alert("Coming soon.");
    // const changePaymentMode = () => window.alert("Coming soon.");

    return (
        <FlexStack>
            <FlexWidget displayName="Aktueller Plan">

                {/*<InfoBox>Testphase aktiv bis 26.10.2025. Bis dahin wird nichts abgebucht.</InfoBox>*/}

                {/*<TableContainer>*/}
                {/*    <Table size={"small"}>*/}
                {/*        <TableRow>*/}
                {/*            <TableCell>Abrechnungsart:</TableCell>*/}
                {/*            <TableCell><strong>Monatlich</strong></TableCell>*/}
                {/*        </TableRow>*/}
                {/*        <TableRow>*/}
                {/*            <TableCell>Nächste Abbuchung:</TableCell>*/}
                {/*            <TableCell>26.10.2025</TableCell>*/}
                {/*        </TableRow>*/}
                {/*        <TableRow>*/}
                {/*            <TableCell>Betrag:</TableCell>*/}
                {/*            <TableCell>29 € zzgl. Ust</TableCell>*/}
                {/*        </TableRow>*/}
                {/*    </Table>*/}
                {/*</TableContainer>*/}

                {subscription
                    ? <CurrentSubscription subscription={subscription}/>
                    : <WarningBox>Kein gültiges Abo vorhanden!</WarningBox>}

                <InfoBox>Die Abrechnung erfolgt über den Zuchtverband</InfoBox>

                {/*<Stack direction="row" gap={2}>*/}
                {/*    <Button variant="contained" startIcon={<SwapHoriz/>} onClick={changeSubscription}>Abrechnung ändern</Button>*/}
                {/*    <Button variant="outlined" startIcon={<CreditCard/>} onClick={changePaymentMode}>Zahlungsmittel ändern</Button>*/}
                {/*    <Button variant="outlined" startIcon={<Cancel/>} color="error" onClick={cancelSubscription}>Abo kündigen</Button>*/}
                {/*</Stack>*/}
            </FlexWidget>

            <InvoiceWidget/>

            {/*<FlexWidget displayName="Abrechnung ändern">*/}
            {/*    <InfoBox>Coming soon.</InfoBox>*/}
            {/*</FlexWidget>*/}

            <SubscriptionTestingWidget/>

        </FlexStack>
    );
};